import { DetailedHTMLProps, HTMLAttributes } from "react"

export const Wrapper = ({ children, style }: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return (
    <div style={{ backgroundColor: '#333333', marginTop: -32, padding: '0 16px', paddingBottom: 48, position: 'relative', ...style }}>{children}</div>
  )
}